import { useIsMobile } from '@/data/hooks/useIsMobile';
import React from 'react';

interface Props {
	children: React.ReactNode;
}

export const DpRenderMobile: React.FC<Props> = ({ children }) => {
	const isMobile = useIsMobile();

	if (!isMobile) {
		return null;
	}

	return <React.Fragment>{children}</React.Fragment>;
};

export const DpRenderDesktop: React.FC<Props> = ({ children }) => {
	const isMobile = useIsMobile();

	if (isMobile) {
		return null;
	}

	return <React.Fragment>{children}</React.Fragment>;
};
